class SiteModal extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    // Delegate on document instead of binding to each trigger element directly, since triggers
    // can be replaced after setup (e.g. carousels that clone/replace their slides on init).
    // Same pattern as compare-products.js and discount-code.js.
    this.listeners.add(document, 'click', this.handleTrigger)

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach((closeEl) => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })
    }

    this.listeners.add(this, 'cancel', (e) => {
      e.preventDefault()
      this.handleClose()
    })
  }

  handleTrigger (event) {
    const selector = this.externalEls?.trigger?.selector
    if (!selector) return

    const trigger = event.target.closest(selector)
    if (!trigger || trigger.dataset.id !== this.dataset.id) return

    this.removeAttribute('inert')
    this.showModal()
    document.body.classList.add('util-SiteOverflowed')
    window.BAO.dispatchEvent(window.BAO.EVENTS.MODAL.OPEN, {
      id: this.dataset.id,
    })
  }

  handleClose () {
    this.close()
    this.setAttribute('inert', '')
    document.body.classList.remove('util-SiteOverflowed')

    window.BAO.dispatchEvent(window.BAO.EVENTS.MODAL.CLOSED, {
      id: this.dataset.id,
    })
  }
}

if (!customElements.get('site-modal')) {
  customElements.define('site-modal', SiteModal, { extends: 'dialog' })
}
